import apiClient from './apiClient';

export const getPageBySlug = async (slug) => {
  try {
    const response = await apiClient.get(`/pages/${slug}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching page:', error);
    throw error;
  }
};
